const AntenistaIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="heating"
  >
    <title>a-icons / 32px / services / heating</title>
    <g fill="none" fillRule="evenodd">
      <g fill={color || '#00008F'}>
        <g>
          <path
            d="M15.432 0c2.842 0 6.202.276 9.462.778l.145.022c.275 0 .446.22.446.497v25.575c0 .262-.201.476-.457.498l-.13.018c-1.156.154-2.318.273-3.47.375v1.753c0 .277-.223.5-.5.5h-.285V31.5c0 .276-.224.5-.5.5H18.16c-.277 0-.5-.224-.5-.5v-1.484h-.286c-.276 0-.5-.223-.5-.5v-1.503c-.34.007-.695.021-1.022.021-.402 0-.826-.015-1.241-.023v1.505c0 .277-.224.5-.5.5h-.285V31.5c0 .276-.224.5-.5.5h-1.984c-.276 0-.5-.224-.5-.5v-1.484h-.285c-.276 0-.5-.223-.5-.5v-1.753c-1.17-.102-2.337-.22-3.476-.376l-.127-.017c-.276 0-.454-.222-.454-.498V1.297c0-.277.224-.5.5-.5C8.113.491 11.376 0 15.432 0zm4.21 30.017h-.982V31h.983v-.983zm-6.816 0h-.983V31h.983v-.983zm7.602-1.983h-2.554v.982h2.554v-.982zm-6.817 0h-2.554v.982h2.554v-.982zm10.874-7.555H7v5.954c2.946.388 6.078.601 8.852.601 2.588 0 5.644-.213 8.633-.602V20.48zm-8.743 1.159c1.157 0 2.1.941 2.1 2.098 0 1.158-.943 2.099-2.1 2.099s-2.099-.941-2.099-2.099c0-1.157.942-2.098 2.1-2.098zm0 1c-.605 0-1.099.493-1.099 1.098 0 .606.494 1.099 1.1 1.099.604 0 1.098-.493 1.098-1.099 0-.605-.494-1.098-1.099-1.098zM15.432 1C11.69 1 8.639 1.426 7 1.715V19.48h17.485V1.727C21.355 1.258 18.15 1 15.432 1zm3.47 3.683c.909 0 1.648.74 1.648 1.648v1.73c0 .91-.74 1.65-1.648 1.65h-6.32c-.908 0-1.647-.74-1.647-1.65v-1.73c0-.909.739-1.648 1.647-1.648zm0 1h-6.32c-.357 0-.647.291-.647.648v1.73c0 .358.29.65.647.65h2.865l1.915-1.916c.195-.195.51-.195.707 0 .195.195.195.512 0 .707L16.86 8.71h2.04c.358 0 .649-.29.649-.649v-1.73c0-.357-.291-.648-.648-.648z"
            transform="translate(-84 -340) translate(84 340)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AntenistaIcon;
